<template>
    <page :busy="busy" :tabs="tabs" :compact-mobile-view="true">
        <router-view
            @busy="handleBusy"
            @remote-lock-redirect="remoteLockRedirect"
        ></router-view>
    </page>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Page from '../../generic/page/page.vue';

    export default {
        name: 'DoorLockSettings',
        components: {
            Page,
        },
        mounted() {
            if (this.$route.path === '/app/door-lock/settings/') {
                const tab = this.getActiveTab();
                if (tab) {
                    this.$router.push(`/app/door-lock/settings/${tab}/`);
                } else {
                    this.remoteLockRedirect();
                }
            }

            this.fetchResortLockAccount();
        },
        computed: {
            ...mapGetters('doorLock', ['resortLockAccount']),
            tabs() {
                const tabs = [];
                tabs.push({
                    title: `RemoteLock / ResortLock`,
                    route: `/app/door-lock/settings/remote-lock/`,
                    active: this.$route.path === `/app/door-lock/settings/remote-lock/`,
                    callback: this.setRemoteLockActiveTab,
                });
                if (this.resortLockAccount) {
                    tabs.push({
                        title: `ResortLock (Legacy)`,
                        route: `/app/door-lock/settings/resort-lock/`,
                        active: this.$route.path === `/app/door-lock/settings/resort-lock/`,
                        callback: this.setResortLockActiveTab,
                    })
                }
                tabs.push({
                    title: `PointCentral`,
                    route: `/app/door-lock/settings/point-central/`,
                    active: this.$route.path === `/app/door-lock/settings/point-central/`,
                    callback: this.setPointCentralActiveTab,
                });
                tabs.push({
                    title: `eRentalLock`,
                    route: `/app/door-lock/settings/e-rental-lock/`,
                    active: this.$route.path === `/app/door-lock/settings/e-rental-lock/`,
                    callback: this.setERentalLockActiveTab,
                });
                tabs.push({
                    title: `Kaba`,
                    route: `/app/door-lock/settings/kaba/`,
                    active: this.$route.path === `/app/door-lock/settings/kaba/`,
                    callback: this.setKabaActiveTab,
                });
                return tabs;
            }
        },
        data() {
            return {
                busy: false,
                localStorageActiveTabKey: 'doorLockSettingsActiveTab',
            }
        },
        methods: {
            handleBusy(busy) {
                this.busy = busy;
            },
            getActiveTab() {
                const valid = ['remote-lock', 'resort-lock', 'point-central', 'e-rental-lock', 'kaba'];
                const tab = localStorage.getItem(this.localStorageActiveTabKey);
                if (valid.includes(tab)) {
                    return tab;
                }
                return null;
            },
            setRemoteLockActiveTab() {
                localStorage.setItem(this.localStorageActiveTabKey, 'remote-lock');
            },
            setResortLockActiveTab() {
                localStorage.setItem(this.localStorageActiveTabKey, 'resort-lock');
            },
            setPointCentralActiveTab() {
                localStorage.setItem(this.localStorageActiveTabKey, 'point-central');
            },
            setERentalLockActiveTab() {
                localStorage.setItem(this.localStorageActiveTabKey, 'e-rental-lock');
            },
            setKabaActiveTab() {
                localStorage.setItem(this.localStorageActiveTabKey, 'kaba');
            },
            remoteLockRedirect() {
                this.$router.push('/app/door-lock/settings/remote-lock/');
                this.setRemoteLockActiveTab();
            },
            async fetchResortLockAccount() {
                try {
                    await this.$store.dispatch('doorLock/fetchResortLockAccount');
                } catch (err) {
                    if (this.$route.path === '/app/door-lock/settings/resort-lock/') {
                        this.remoteLockRedirect();
                    }
                }
            }
        }
    }
</script>